import { useApolloClient } from "@apollo/client";
import { ModalOpenButton, useScreenWidth } from "@msys/ui";
import { Button } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import {
  dataURLtoFile,
  uploadFileToUploadCare,
} from "../../attachments/helpers.js";
import { useAcceptQuoteMutation } from "../Quotes.generated.js";
import { AcceptQuoteModal } from "../modals/AcceptQuoteModal.js";

interface Props {
  docId: string;
  projectId: string;
  handleComplete?: () => Promise<unknown> | unknown;
}

export const AcceptQuoteButton = ({
  docId,
  projectId,
  handleComplete,
}: Props) => {
  const { t } = useTranslate(["Quote", "Global"]);
  const { isMaxPhone } = useScreenWidth();

  const client = useApolloClient();
  const [acceptQuote] = useAcceptQuoteMutation({ client });

  return (
    <ModalOpenButton
      Modal={AcceptQuoteModal}
      modalProps={{
        docId: docId,
        projectId: projectId,
        handleComplete: async ({ place, date, signature }) => {
          const attachment = await uploadFileToUploadCare(
            dataURLtoFile(signature, "signature"),
            false
          );

          await acceptQuote({
            variables: {
              input: {
                projectId,
                docId,
                signature: {
                  place: place,
                  date: date.format("YYYY-MM-DD"),
                  signature: {
                    url: attachment.url,
                    title: attachment.title,
                    mimeType: attachment.mimeType,
                  },
                },
              },
            },
          });

          await handleComplete?.();
        },
      }}
    >
      <Button color="secondary" variant="contained">
        {isMaxPhone
          ? t("Accept", { ns: "Global" })
          : t("Accept Quote", { ns: "Quote" })}
      </Button>
    </ModalOpenButton>
  );
};
